import React from 'react';
import './css/Main.css';

export default function MainComparison() {
  return (
    <>
      <section className="comparison-section">
        <h2 className="section-title">THE OLD WAY VS THE P2PAUTO WAY</h2>
        <div className="comparison">
          <div className="box old-way">
            <h3>✗ The Old Way</h3>
            <p>
              Seller → Dealer → Consumer
            </p>
            <br/>
            <p>
              Sellers receive lower prices.<br/>
              Buyers pay dealer markups.
            </p>
          </div>
          <div className="box new-way">
            <h3>✓ The P2PAUTO Way</h3>
            <p>
              Seller → P2PAUTO → Consumer
            </p>
            <br/>
            <p>
              Higher value for sellers.<br/>
              Better deals for buyers.
            </p>
          </div>
        </div>
      </section>
      <section className="comparison-section-mobile">
        <h2 className="section-title">WHY P2PAUTO?</h2>
        <div className="comparison">
          <div className="box old-way">
            <h3>✗ The Old Way</h3>
            <p>
              Seller → Dealer → Consumer
            </p>
            <br/>
            <p>
              ✗ Sellers receive lower prices.<br/>
              ✗ Buyers pay dealer markups.
            </p>
          </div>
          <div className="box new-way">
            <h3>✓ The P2PAUTO Way</h3>
            <p>
              Seller → P2PAUTO → Consumer
            </p>
            <br/>
            <p>
              ✓ Higher value for sellers.<br/>
              ✓ Better deals for buyers.
            </p>
          </div>
        </div>
      </section>
    </>
  )
}